import downloadHttpClient from './amio-download.http-client'

class StatsExportService {

  async exportBotStatsCsv({ botIds, dateFrom, dateTo }) {
    const params = { botIds: botIds.join(',') }
    if (dateFrom) params.dateFrom = dateFrom
    if (dateTo) params.dateTo = dateTo

    try {
      const response = await downloadHttpClient.get('/analytics/bot-stats-csv', { params, responseType: 'blob' })
      return response.data
    } catch (err) {
      throw await this._toReadableError(err)
    }
  }

  // The response is a Blob (responseType: 'blob'), so an error body is also a Blob.
  // Read it as text to surface a meaningful message instead of "[object Object]".
  async _toReadableError(err) {
    const data = err.response?.data
    if (data && typeof data.text === 'function') {
      try {
        const text = await data.text()
        const parsed = JSON.parse(text)
        return new Error(parsed?.details?.errors?.[0]?.message || parsed?.message || text)
      } catch (e) {
        // not JSON / not readable - fall through to the generic message
      }
    }
    return new Error(err.message || 'Export failed.')
  }
}

export default new StatsExportService()
